<template>
    <div>
        <div id="spinner" v-show="loading">
            <div class="text-center mt-5">
                <h4 class="text-muted">
                    Loading...
                </h4>
                <div class="spinner-border" style="margin-top:10px;">
                </div>
            </div>
        </div>

        <!-- Search Panel -->
        <div v-show="!loading">
            <!-- Error Message-->
            <div id="errorDiv" style="display:none;">
                <div class="alert alert-danger alert-dismissible" role="alert" id="errorMessage" ref="errorMessage">
                    <button type="button" class="close" aria-label="Close" v-on:click.prevent="clearErrorMessage"><span aria-hidden="true">&times;</span></button>
                    {{errorMessage}}
                </div>
            </div>
            <div class="panel panel-default hidden-print" style="margin-left: 10px;margin-right: 10px;margin-top: 10px;">
                <div class="panel-body panel-min-top-margin">
                    <h4 class="h4-custom-back box-shadow--6dp">
                        <span>
                            <img v-bind:src="agencyLogo" style="max-height: 100px; max-width: 350px; display:inline-flex" v-if="agencyLogoExists">
                            <span v-else style="font-size: 26px"><b>{{agencyName}}</b></span>
                            <span style="font-size: 24px; display:inline-flex;">&nbsp;&nbsp;Public Jail Roster</span>
                            <span class="text-muted pull-right hidden-sm" style="display:flex"><i>{{agencyOri}}</i></span>
                        </span>
                    </h4>
                    <hr class="hr-light-padding" />
                    <!-- Search Panel -->
                    <div class="panel-default">
                        <div class="panel-body panel-min-top-margin">
                            <h5>
                                <b>
                                    <i class="fa fa-id-card icon-right-padding" aria-hidden="true"></i>Incarcerated
                                    - Results: {{roster.length}}
                                    <span class="text-muted">
                                        <i>({{displaySearchLiteral}})</i>
                                    </span>
                                </b>
                            </h5>
                            <hr class="hr-light-padding" />
                            <!-- Search Fields -->
                            <div class="row">
                                <div class="col-md-2 pl-1-start pl-1-hide col-xs-12">
                                    <div class="form-group">
                                        <label>
                                            <i class="fa fa-search" aria-hidden="true"></i>&nbsp;&nbsp;Name Filter:
                                        </label>
                                        <input class="form-control" v-model="searchValue" />
                                        <!--v-on:change="searchByName"-->
                                    </div>
                                </div>

                                <div class="col-md-2 pl-1 pl-1-hide col-xs-12">
                                    <div class="form-group">
                                        <label>
                                            <i class="fa fa-filter" aria-hidden="true"></i>&nbsp;&nbsp;Order By:
                                        </label>
                                        <select class="form-control" v-model="orderByValue" @change="lazyLoadImages">
                                            <option value=""></option>
                                            <option value="daysInJailShortest">SHORTEST IN JAIL</option>
                                            <option value="daysInJailLongest">LONGEST IN JAIL</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row col-md-12">
                                <div class="text-center">
                                    <div class="row">
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-purple" v-on:click.prevent="setSearchByLetter('RECENT')">
                                            <i class="fa fa-clock-o" aria-hidden="true"></i>&nbsp;&nbsp; RECENT BOOKINGS
                                        </button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-info" v-on:click.prevent="setSearchByLetter('ALL')">ALL</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('A')">A</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('B')">B</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('C')">C</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('D')">D</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('E')">E</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('F')">F</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('G')">G</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('H')">H</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('I')">I</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('J')">J</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('K')">K</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('L')">L</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('M')">M</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('N')">N</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('O')">O</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('P')">P</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('Q')">Q</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('R')">R</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('S')">S</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('T')">T</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('U')">U</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('V')">V</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('W')">W</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('X')">X</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('Y')">Y</button>
                                        <button type="button" style="font-size: 11px;" class="btn-sm btn-primary" v-on:click.prevent="setSearchByLetter('Z')">Z</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Search Results -->
            <div class="row" style="margin-left: .5px;margin-right: .5px;">
                <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12" v-for="item in filteredRoster" v-bind:key="item.name_Id">
                    <div class="panel panel-default max-height-panel" style="font-size: 11px !important">
                        <div class="panel-body">
                            <!--<div v-if="hideVinesLink === 'N' && siteIdVines && agencyVines" style="margin-left: 713px; margin-top: -10px; margin-right: -10px">
                                <a v-bind:href="`http://www.vinelink.com/servlet/SubjectSearch?siteId=${siteIdVines}&agency=${agencyVines}&offenderID=${item.ccn}`" target="_blank">
                                    <span style="font-size: 12px">Register for release notification</span>
                                </a>
                            </div>-->
                            <div v-if="hideVinesLink === 'N' && siteIdVines && agencyVines" class="pull-right" style="margin-top: -15px">
                                <a v-bind:href="`http://www.vinelink.com/servlet/SubjectSearch?siteId=${siteIdVines}&agency=${agencyVines}&offenderID=${item.ccn}`" target="_blank">
                                    <img alt="VINES" src="../assets/Logo_RGB_VINE_white.png" width="80" height="30" style="background: transparent; cursor:pointer;" title="Register for release notification">
                                </a>
                            </div>
                            <div class="row">
                                <div class="col-md-3 col-xs-12" style="max-width:135px;">
                                    <photo-component v-if="hidePhoto === 'N'"
                                                     :ori="agencyOri"
                                                     :ccn="item.ccn"
                                                     width="105"
                                                     height="160"
                                                     :nameid="item.nameid"
                                                     :skip_auth="true">

                                    </photo-component>
                                    <img v-else
                                         class="img-thumbnail"
                                         id="person-photo"
                                         src="/images/demophoto1.png">
                                </div>
                                <div class="col-md-10 col-xs-12">
                                    <div class="row">
                                        <div class="col-md-7 col-xs-6">
                                            <label class="text-uppercase">
                                                <b style="color:orange">{{item.last}}, {{item.first}} {{item.middle}} {{item.suffix}}</b>
                                            </label>
                                        </div>
                                        <div class="col-md-3 col-xs-6">
                                            <b style="color:orange">
                                                <label>Arrested: </label>&nbsp; {{formatDate(item.arr_date_time)}}
                                            </b>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-3 col-sm-6 col-xs-6">
                                            <label>Days Jailed: </label> {{addCurrentDay(item.days_in_jail)}}
                                        </div>
                                        <div class="col-md-3 col-sm-6 col-xs-6">
                                            <label>Race/Sex: </label> {{item.race}}/{{item.sex}}
                                        </div>
                                        <div class="col-md-3 col-sm-6 col-xs-6">
                                            <label>DOB: </label> {{item.dob}}
                                            <span class="text-muted">(Age:{{item.age}})</span>
                                        </div>
                                        <div class="col-md-3 col-sm-6 col-xs-6 hidden-md">
                                            <label>Hgt/Wgt: </label> {{heightMask(item.height)}}/{{item.weight}}
                                        </div>
                                    </div>
                                    <div class="row" v-if="item.rel_date_time">
                                        <div class="col-md-12 col-xs-12">
                                            <label>Released: </label> {{formatDate(item.rel_date_time)}}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4 col-sm-6 col-xs-6">
                                            <label>Eyes/Hair: </label> {{item.eyes}}/{{item.hair}}
                                        </div>
                                        <div class="col-md-8 col-sm-6 col-xs-12 text-uppercase">
                                            <label>Arresting Agency: </label> {{item.arresting_agency}}
                                        </div>
                                    </div>
                                    <div class="row" v-if="showPublicAddress && item.public_address">
                                        <div class="col-md-12 col-xs-12">
                                            <label>Address: </label> {{item.public_address}}
                                        </div>
                                    </div>
                                    <div style="overflow-x: auto;overflow-y:auto;max-height:88px;" v-if="!item.rel_date_time">
                                        <table class="table table-bordered table-condensed table-striped" border="1" style="font-size:13px">
                                            <thead>
                                                <tr>
                                                    <th style="width:70%">Charge</th>
                                                    <th>Warrant #</th>
                                                    <th class="col-sm-1">Bond</th>
                                                </tr>
                                            </thead>
                                            <tr v-for="charge in item.charges" style="overflow-x: auto;overflow-y:auto;max-height:150px;" v-bind:key="charge.blah">
                                                <td>
                                                    {{charge.charge_code}} - &nbsp;
                                                    <span v-if="charge.legacy_literal">{{charge.legacy_literal}}</span>
                                                    <span v-else>{{charge.charge_literal}}</span>
                                                    <span v-show="showChargeComments === true">{{charge.motn_comments}}</span>
                                                </td>
                                                <td>{{charge.warrant_no}}</td>
                                                <td v-if="charge.bond_amount === '0'">No Bond</td>
                                                <td v-else>${{charge.bond_amount}}</td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div v-else>
                                        <br />
                                        <div class=" panel-default">
                                            <label style="font-size: 15.5px !important;">
                                                <span class="text-info">
                                                    <i class="fa fa-exclamation-circle icon-right-padding"></i>
                                                    Charges are not available for released people.
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // var response = await this.$http.get(`${process.env.VUE_APP_API_ENDPOINT}/Roster/GetJailRoster?agencyOri=TX1234567`)
    import { PhotoApi } from '../services/PhotoApi'
    import moment from 'moment'
    import PhotoComponent from '../components/PhotoComponent'

    export default {
        setup() {
        },
        data() {
            return {
                agencyOri: null,
                roster: {},
                successMessage: null,
                errorMessage: null,
                loading: true,
                searchValue: null,
                orderByValue: null,
                agencyName: null,
                searchByLetter: 'RECENT',
                base64: '',
                hidePhoto: 'N',
                showPublicAddress: false,
                hideVinesLink: 'Y',
                siteIdVines: null,
                agencyVines: null,
                agencyLogo: '',
                agencyLogoExists: false
            }
        },
        computed: {
            displaySearchLiteral() {
                return `Searching ${this.searchByLetter}`;
            },
            showChargeComments() {
                if (this.agencyOri === 'LA0010000' || this.agencyOri === 'TX2380000' || this.agencyOri === 'FL0070000' || this.agencyOri === 'TX0180000') {
                    return false;
                }
                else {
                    return true;
                }
            },
            filteredRoster: function () {
                var vue = this;

                if ((vue.searchValue == "" || vue.searchValue == null) && vue.orderByValue == null) {
                    return vue.roster;
                }


                //if (vue.orderByValue == null) {
                //    return vue.roster;
                //}

                if (vue.orderByValue != null) {
                    if (vue.orderByValue == "daysInJailShortest") {

                        return vue.roster.sort(function (a, b) {
                            vue.orderByValue = null;
                            return ((Number(a.days_in_jail) == Number(b.days_in_jail)) ? 0 : ((Number(a.days_in_jail) > Number(b.days_in_jail)) ? 1 : -1));
                        })
                    }
                    if (vue.orderByValue == "daysInJailLongest") {

                        return vue.roster.sort(function (a, b) {
                            vue.orderByValue = null;
                            return ((Number(a.days_in_jail) == Number(b.days_in_jail)) ? 0 : ((Number(a.days_in_jail) < Number(b.days_in_jail)) ? 1 : -1));
                        })
                    }
                }

                return vue.roster.filter(function (roster) {

                    return roster.last.toUpperCase().indexOf(vue.searchValue.toUpperCase()) >= 0 ||
                        roster.first.toUpperCase().indexOf(vue.searchValue.toUpperCase()) >= 0 ||
                        roster.middle.toUpperCase().indexOf(vue.searchValue.toUpperCase()) >= 0;
                });
            }
        },
        methods: {
            lazyLoadImages() {
                // lazy image loading
                let images = document.querySelectorAll("img");
                //console.log(images);

                // The API options: when 20% of the image is visible.
                const imgOptions = {
                    threshold: 0.2
                };

                var imgObserver = new IntersectionObserver(function (entries, imgObserver) {
                    entries.forEach((entry) => {
                        if (!entry.isIntersecting) return;

                        // if it's visible
                        const img = entry.target

                        if (img.id === 'person-photo') {
                            let ccn = img.attributes['data-ccn']?.nodeValue;
                            let nameid = img.attributes['data-nameid']?.nodeValue;
                            let ori = img.attributes['data-ori']?.nodeValue;

                            PhotoApi.getPhoto(ori, ccn, nameid, img);
                        }
                        imgObserver.unobserve(entry.target);
                    })
                }, imgOptions);

                images.forEach((img) => {
                    imgObserver.observe(img)
                })
            },
            addCurrentDay(val) {

                if (val) {
                    return (Number(val) + 1);
                }
                return val;
            },
            getAgencyPoto() {

                return

                //this.$http.get(`${process.env.VUE_APP_API_ENDPOINT}/Roster/GetAgencyPhoto?ori=${this.agencyOri}`)
                //    .then(function (r) {
                //        if (r.data.status === '200') {
                //            this.base64 = r.data.message;
                //        }
                //        else {
                //            console.log(r.data.message);
                //        }
                //    })
            },
            formatDate(value) {
                if (value) {
                    value = moment(value).format('MM/DD/YYYY HH:mm')
                }
                return value;
            },
            phoneNumberFormat: function (value) {

                if (value == "" || value == null) {
                    return value;
                }
                else {
                    var front = value.substring(0, 3);
                    var back = value.substring(3, 7);
                    return value = front + "-" + back;
                }
            },
            heightMask: function (item) {

                if (item == null) {
                    return item;
                }
                else {
                    var front = item.substring(0, 1);
                    var back = item.substring(1, 4);
                    item = front + "'" + back + "''";
                    return item;
                }
            },
            clearErrorMessage: function () {
                var errorDiv = document.getElementById("errorDiv");
                errorDiv.style.display = "none";
                this.errorMessage = "";
            },
            async getJailRoster() {
                this.loading = true;

                var vue = this

                await this.$http.post(`${process.env.VUE_APP_API_ENDPOINT}/Roster/GetJailRosterPost?agencyOri=${this.agencyOri}&searchByLetter=${this.searchByLetter}`)
                    .then(function (response) {
                        vue.loading = false
                        vue.roster = response.data;

                        setTimeout(() => {
                            vue.lazyLoadImages();
                        }, 200)
                    })
                    .catch(function (response) {
                        vue.loading = false
                        console.error("Jail Roster was not returned. " + response);
                    });
            },
            getAgencyName: function () {
                //`${process.env.VUE_APP_API_ENDPOINT}/Roster/GetJailRoster?agencyOri=TX1234567`
                var vue = this

                this.$http.get(`${process.env.VUE_APP_API_ENDPOINT}/Roster/GetAgencyName?agencyOri=${this.agencyOri}`)
                    .then(function (response) {
                        vue.loading = false;
                        if (response.status !== 401) {
                            vue.agencyName = response.data;
                        }
                    })
            },
            setSearchByLetter: function (value) {
                this.searchByLetter = value
                this.getJailRoster()
            },
            async getParams() {
                try {
                    const r = await this.$http.get(`${process.env.VUE_APP_API_ENDPOINT}/Roster/GetParams?agencyOri=${this.agencyOri}`);
                    if (r) {
                        for (var i = 0; i < r.data.length; i++) {
                            if (r.data[i].codE_TITLE === 'HIDE PUBLIC JAIL ROSTER PHOTO') {
                                this.hidePhoto = r.data[i].codE_VALUE;
                            }
                            else if (r.data[i].codE_TITLE === 'SHOW PUBLIC JAIL ROSTER ADDRESS') {
                                this.showPublicAddress = r.data[i].codE_VALUE === 'Y';
                            }
                            else if (r.data[i].codE_TITLE === 'HIDE VINES LINK') {
                                this.hideVinesLink = r.data[i].codE_VALUE;
                            }
                            else if (r.data[i].codE_TITLE === 'SITEID VINES') {
                                this.siteIdVines = r.data[i].codE_VALUE;
                            }
                            else if (r.data[i].codE_TITLE === 'AGENCY VINES') {
                                this.agencyVines = r.data[i].codE_VALUE;
                            }
                        }
                    }
                } catch (e) {
                    console.error("Error Getting Parameters" + e.toString());
                }
            },
            async checkAgencyLogo() {
                try {
                    const r = await this.$http.get(`${process.env.VUE_APP_API_ENDPOINT}/Roster/CheckAgencyLogo?agencyOri=${this.agencyOri}`)
                    console.log(r.data);
                    return r.data;

                } catch (e) {
                    console.error("Error Checking Agency Logo " + e.toString());
                }

            },
            getAgencyLogo() {
                try {
                    let filePath = "";
                    let fileName = this.agencyOri + '.png'
                    filePath = require("../assets/" + fileName);
                    return filePath;

                } catch (e) {
                    console.error("Error Getting Agency Logo " + e.toString());
                }
            },
            removeClickIdentifiers(url) {
                try {
                    const urlObject = new URL(url);
                    const params = new URLSearchParams(urlObject.search);

                    const identifiers = ['fbclid', 'gclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

                    identifiers.forEach(identifier => {
                        params.delete(identifier);
                    });

                    var paramString = params.toString();

                    // using URLSearchParams to parse the params will add an = sign to the end
                    // of the ORI param because it doesn't follow the typical param pattern
                    if (paramString.endsWith("=")) {
                        paramString = paramString.substring(0, paramString.length - 1);
                    }

                    urlObject.search = paramString;
                    return urlObject.toString();
                } catch (error) {
                    console.error("Invalid URL:", error);
                    return url;
                }
            }
        },
        async created() {
            var currentUrl = window.location.href;

            if (currentUrl.indexOf('&') > 0) {
                window.location.href = this.removeClickIdentifiers(window.location.href)
            }

            this.agencyOri = currentUrl.split("_").pop();
            if (this.agencyOri) {
                this.agencyOri = this.agencyOri.toUpperCase();
            }
            this.agencyLogoExists = await this.checkAgencyLogo();
            this.agencyLogo = this.getAgencyLogo();
            this.getAgencyName();
            await this.getParams();
            await this.getJailRoster();
            this.getAgencyPoto();
        },
        mounted: function () {
            //this.lazyLoadImages;
        },
        components: {
            PhotoComponent
        }
    }
</script>

<style>
    @media (min-width: 990px) {
        .max-height-panel {
            overflow-x: auto;
            overflow-y: auto;
            height: 195px;
        }
    }
</style>
